import React from 'react'
import "./Footer.scss";
import {links as data} from "../../SocialMediaData";

const Footer = () => {
  return (
    <footer>
        <div className="smLinks">
          {
            data.map((item, id)=>{
              return (
                <div className="smlink"><a href={item.link} target="_blank">{item.icon}</a></div>
              )
            })
          }
        </div>

        <div className='outro'>
            Made with 💖 by <a href="https://twitter.com/DevlprZee">Ziya Sayed</a>
        </div>
    </footer>
  )
}

export default Footer